;(function() {

	//
	// Třída ModalAlert dědí od třídy Modal.
	//
	function ModalAlert(element) {
		Modal.call(this, element);
		this.body = this.element.querySelector(".modal-alert-body");
	}
	ModalAlert.prototype = Object.create(Modal.prototype);
	ModalAlert.prototype.constructor = ModalAlert;

	//
	// innerHTML - která nastavuje obsah dialogu - chceme mít jako property, nikoliv jako metodu. Proč?
	// Jenom kvůli konzistenci se standardní property innerHTML na HTML elementu.
	//
	Object.defineProperty(ModalAlert.prototype, "innerHTML", { set: function(html) {
		this.body.innerHTML = html;
	}});


	//
	// Vytvoří modální dialog i s obsahem.
	//
	ModalAlert.create = function() {
		var modal = Modal.create();

		// Obyčejný modální dialog obohatíme o obsah.
		modal.innerHTML = "<div class='modal-dialog'><div class='modal-content'><div class='modal-dialog-top'><a href='#' data-modal='close'><span class='icm icm-x'></span></a></div><div class='modal-dialog-body'><div class='row'><div class='col-auto'><span class='icm icm-alert-circle icm-2x text-danger'></span></div><div class='col modal-alert-body'></div></div></div><div class='modal-dialog-body text-center'><a href='#' data-modal='close' class='btn btn-primary'>Zavřít</a></div></div></div>";

		return modal;
	}


	//
	// Vytvoří nebo vrátí existující instanci modálního dialogu.
	//
	ModalAlert.get = function(element) {
		return Modal.get(element, ModalAlert);
	}


	//
	// Zobrazí chybovou hlášku.
	//
	ModalAlert.error = function(message) {
		var modal = ModalAlert.get();

		modal.innerHTML = message;

		modal.open();
	}

	window.ModalAlert = ModalAlert;

}());